module.exports = __webpack_public_path__ + "static/media/MyHealingDiary.822d4865.jpg";